import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable camelcase */

// import sha256 from 'crypto-js/hmac-sha256';
// import md5 from 'crypto-js/md5';
import qs from 'qs';
import { KEWLSensorTrack } from '@ui/packages/pcv2/assets/utils/util';
import rsa from './rsa';
import publicrsa from './publicrsa';

// /Android|HTC|webOS|iPhone|iPod|BlackBerry/i.test(userAgent);
var apiConfig = {
  config: {
    baseUrl: '//featuremix-qa.live.liveme.com',
    // client_id: 213704893,
    // client_secret: '0882C07F47EAFBE1EF4BA0DBAFB080D6',
    business: 'liveme',
    redirect_uri: '//www.liveme.com/'
  },
  website: '//www.liveme.com/',
  toBase64: window.Base64.toBase64,
  androidid: '',
  businessConfig: {
    alias: 'liveme',
    thirdchannel: 6
  },
  devtype: window.KEWLApp.UAInfo.IsAndroid || window.KEWLApp.UAInfo.IsIOS ? 'H5_WEB' : 'WEB',
  init: function init(baseUrl, business, redirectUri, alias) {
    this.config = {
      baseUrl: baseUrl,
      // client_id: clientId,
      // client_secret: secret,
      business: business,
      redirect_uri: redirectUri
    };
    if (alias) {
      this.businessConfig.alias = alias;
    } else {
      // eslint-disable-next-line no-nested-ternary
      this.businessConfig.alias = business === 'royal_live' ? 'ar' : business === 'a_live' ? 'us' : business;
    }
    this.website = redirectUri;
  },
  axiosClient: function axiosClient(url, params) {
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
    if (params.param) {
      params.param = _objectSpread(_objectSpread({}, {
        transaction_id: this.uuid32(),
        // 为全小写随机字符串
        tongdun_black_box: '',
        // 同盾参数，没有传空
        tmx_session_id: localStorage ? localStorage.getItem('tmxToken') : '',
        // tmx参数
        appstyle: window.baseAxios && window.baseAxios.loginReg && window.baseAxios.loginReg.appstyle || '',
        devtype: this.devtype,
        isKewlApp: window.KEWLApp && window.KEWLApp.isKEWLApp
        // app_type: 'h5_inapp',
        // mobile_os: 'web'
      }), params.param);
    }
    var baseData = _objectSpread(_objectSpread(_objectSpread({}, this.businessConfig), {
      h5: 1,
      tuid: 'tuid',
      type: 'post',
      risk_token: localStorage ? localStorage.getItem('tmxToken') : '',
      isKewlApp: window.KEWLApp && window.KEWLApp.isKEWLApp
      // app_type: 'h5_inapp',
      // mobile_os: 'web'
    }), params);
    var baseParam = {};
    if (method === 'post') {
      baseParam.headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
      var tongdunBox = window.TONGDun && window.TONGDun.getBlackBox() || '';
      if (url !== '/Channel/report') {
        baseData.tongdun_black_box = tongdunBox;
      }
      if (baseData.param) {
        baseData.param.tongdun_black_box = tongdunBox;
      }
      baseData.param = JSON.stringify(params.param);
      baseParam.data = qs.stringify(baseData);
    } else {
      baseParam.params = baseData;
    }
    return window.KEWLHttp("".concat(this.config.baseUrl).concat(url), _objectSpread({
      method: method
    }, baseParam)).then(function (response) {
      if (!response.data || +response.data.status !== 200 && response.data.status !== 'success') {
        return Promise.reject(response);
      }
      var oneSts = response.data && response.data.status;
      var secSts = response.data && response.data.data && response.data.data.status;
      if (window.errorMessageTMX && (window.errorMessageTMX[oneSts] || window.errorMessageTMX[secSts])) {
        response.errorMessageTMXTip = true;
        return Promise.reject(response);
      }
      return response.data.data;
    });
  },
  uuid32: function uuid32() {
    var s = [];
    var hexDigits = '0123456789abcdef';
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < 32; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    // eslint-disable-next-line no-bitwise
    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    // eslint-disable-next-line no-multi-assign
    return s.join('');
  },
  uuid: function uuid() {
    var s = [];
    var hexDigits = '0123456789abcdef';
    // eslint-disable-next-line no-plusplus
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    // eslint-disable-next-line no-bitwise
    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    // eslint-disable-next-line no-multi-assign
    s[8] = s[13] = s[18] = s[23] = '-';
    return s.join('');
  },
  // sign(param) {
  //     param.sort();
  //     const pstr = param.join('|');
  //     const sign = md5(sha256(pstr, this.config.client_secret).toString()).toString();
  //     return sign;
  // },
  /**
     * 获得国家码
     */
  getCountryCodeByIp: function getCountryCodeByIp() {
    return this.axiosClient('/search/getcountryCode', {}, 'get');
  },
  /**
     * 判断用户是否存在
     * @param {*} name 账户名
     */
  userIsExist: function userIsExist(name) {
    return this.axiosClient('/Channel/report', {
      url: '/1/api/exist_account',
      // 替换
      type: 'get',
      param: {
        name: name
      }
    });
  },
  /**
     * 登录获取token
     * @param {*} name 账户名字
     * @param {*} password 密码（去掉，verify_pwd替代）
     * @param {*} captcha 验证码
     */
  channelSignin: function channelSignin(name, password, captcha, mPublicKey) {
    // return this.axiosClient('/channel/signin', {
    //     name,
    //     sr: 1,
    //     password: this.toBase64(password),
    //     captcha
    // }, 'post');
    return this.axiosClient('/Channel/report', {
      url: '/2/api/user/verify_login',
      param: {
        redirect_uri: this.config.redirect_uri,
        devtype: 'web',
        name: name,
        verify_pwd: publicrsa.encryptRsaPublic(password, mPublicKey),
        // password: this.toBase64(password),
        captcha: captcha
      }
    });
    // 2/api/user/verify_login
  },
  /**
     * 邮箱登录获取验证码
     * @param {*} email 邮箱
     * @param {*} ip ip
     */
  emailCaptcha: function emailCaptcha(email) {
    return this.axiosClient('/Channel/report', {
      url: '/1/api/user/captcha',
      param: {
        email: email
      }
    });
  },
  /**
     * 邮箱登录获取验证码
     * @param {*} mobile 手机
     * @param {*} ip ip
     */
  mobileCaptcha: function mobileCaptcha(mobile) {
    return this.axiosClient('/Channel/report', {
      url: '/1/api/user/captcha',
      param: {
        mobile: mobile,
        need_slide: 2
      }
    });
  },
  /**
     * 发送邮件
     * @param {*} email 邮箱
     * @param {*} type 激活是0，忘记密码是3
     * @param {*} accessToken token
     */
  sendEmail: function sendEmail(email, type, accessToken) {
    return this.axiosClient('/Channel/report', {
      url: '/1/api/user/send_email',
      has_token: 1,
      param: {
        business: this.config.business,
        access_token: accessToken,
        type: type,
        email: email
      }
    });
  },
  /**
     * 获取账户信息，判断是否邮箱没有激活
     * @param {*} accessToken token
     */
  isActiveEmail: function isActiveEmail(accessToken) {
    return this.axiosClient('/Channel/report', {
      url: '/1/api/account/info',
      type: 'get',
      has_token: 1,
      param: {
        access_token: accessToken
      }
    });
  },
  /**
     * 获取公钥，RSA非对称加密
     * @param {*} tongdun_black_box 同盾风控参数
     */
  rsaKey: function rsaKey() {
    var tongdun_black_box = window.TONGDun && window.TONGDun.getBlackBox() || '';
    return this.axiosClient('/Channel/report', {
      url: '/2/api/user/get_public_key',
      type: 'get',
      param: {
        devtype: 'web',
        tongdun_black_box: tongdun_black_box
      }
    });
  },
  /**
     * 登录信息接口
     * @param {*} accessToken accessToken
     * @param {*} regType 手机104 邮箱108
     * @param {*} keep keep keep=0是登录 =1 是注册
     * @param {*} countrycode countrycode
     */
  userInfo: function userInfo(accessToken, regType) {
    var keep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var androidid = this.uuid();
    this.androidid = androidid;
    return this.axiosClient('/channel/login', {
      access_token: accessToken,
      reg_type: regType,
      androidid: androidid,
      keep: keep,
      ver: '4.8.50' // for 恢复账号弹框提示
    }, 'post');
  },
  /**
   * 确认清除账号删除状态
   * @param userInfo
   * @returns
   */
  clearAccountStatus: function clearAccountStatus(userInfo) {
    return this.axiosClient('/artemis/v1/user/clear_delete_account_status', {
      uid: userInfo.user.uid,
      tuid: userInfo.user.uid,
      token: userInfo.token
    }, 'post');
  },
  /**
     * 注册接口
     * @param {*} name 账户名
     * @param {*} password 密码
     * @param {*} captcha 邮箱注册需要验证码
     * @param {*} verifyCode 手机注册验证码
     * @param {*} verifyCodeType 手机注册验证码类型
     */
  register: function register(name, password) {
    var _this = this;
    var captcha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var verifyCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var verifyCodeType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var tongdun_black_box = window.TONGDun && window.TONGDun.getBlackBox() || '';
    var timestamp = "".concat(new Date().valueOf()).substr(0, 10);
    // const paramArr = [
    //     name, this.config.client_id, timestamp
    // ];
    // const sign = this.sign(paramArr);
    var serveConfig = {
      url: '/2/api/user/verify_register',
      type: 'post',
      param: {
        redirect_uri: this.config.redirect_uri,
        business: this.config.business,
        code_type: '2',
        need_active: 'true',
        devtype: this.devtype,
        timestamp: timestamp,
        // sign,
        name: name,
        captcha: captcha,
        password: rsa.encryptRsaPublic(password),
        verify_code: verifyCode,
        verify_code_type: verifyCodeType,
        tongdun_black_box: tongdun_black_box
      }
    };
    if (tongdun_black_box) {
      KEWLSensorTrack({
        lmweb_clickText: '注册',
        tongdun_black_box: tongdun_black_box,
        lmweb_tabName: 'success'
      });
      // 注册场景 tongdun_black_box 获取成功 进行注册
      return this.axiosClient('/Channel/report', serveConfig);
    }
    return new Promise(function (reject, resolve) {
      // 超时机制
      clearTimeout(_this.timer);
      _this.timer = setTimeout(function () {
        // 提示用户刷新重试
        window.TONGDun && window.TONGDun.init();
        // 第二次失败 触发超时机制 最后一次获取 ongdun_black_box操作 注册阻止
        KEWLSensorTrack({
          lmweb_clickText: '注册',
          tongdun_black_box: '',
          lmweb_tabName: 'tongdun_fail_2'
        });
        _this.timer = null;
        resolve('tongdun_fail');
      }, 1000 * _this.timeout);

      // 注册场景 tongdun_black_box获取失败 进行再次获取 ongdun_black_box操作
      window.TONGDun && window.TONGDun.init(function (data) {
        console.log('TONGDun.init', data);
        if (!_this.timer) {
          return;
        }
        KEWLSensorTrack({
          lmweb_clickText: '注册',
          tongdun_black_box: data,
          lmweb_tabName: 'tongdun_fail_1'
        });
        clearTimeout(_this.timer);
        _this.timer = null;
        serveConfig.param.tongdun_black_box = data;
        _this.axiosClient('/Channel/report', serveConfig).then(function (data) {
          reject(data);
        }).catch(function (response) {
          resolve(response);
        });
      });
    });
  },
  /**
     * 重置密码
     * @param {*} accessToken token
     * @param {*} pwd 新密码
     */
  resetPwd: function resetPwd(accessToken, pwd) {
    return this.axiosClient('/Channel/report', {
      url: '/1/api/set_password',
      // 替换
      type: 'post',
      has_token: 1,
      param: {
        access_token: accessToken,
        pwd: pwd
      }
    }, 'post');
  },
  /**
     * 注册时发送手机验证码
     * @param {*} mobile 手机号
     * @param {*} itc 区号
     * @param {*} country 区号国家
     * @param {*} type 场景 4：注册，3：忘记密码
     */
  sendRegCode: function sendRegCode(mobile, itc, country, captcha) {
    var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 4;
    return this.axiosClient('/Channel/report', {
      // url: '/1/api/user/send_sms',
      url: '/2/api/user/verify_sms',
      type: 'post',
      param: {
        type: type,
        business: this.config.business,
        mobile: mobile,
        itc: itc,
        client_country_code: country,
        captcha: captcha,
        need_slide: 2
      }
    }, 'post');
  },
  /**
     * 忘记密码时发送手机验证码
     * @param {*} mobile 手机号
     * @param {*} itc 区号
     */
  sendFgtCode: function sendFgtCode(mobile, itc) {
    return this.axiosClient('/Channel/report', {
      url: '/2/api/send_sms',
      // 替换
      type: 'post',
      param: _objectSpread(_objectSpread({}, {
        type: 3,
        business: this.config.business
      }), {}, {
        length: 6,
        mobile: mobile,
        itc: itc,
        need_slide: 2
      })
    }, 'post');
  },
  /**
     * 检验验证码
     * @param {*} name 手机号
     * @param {*} code 验证码
     */
  checkFgtCode: function checkFgtCode(name, code) {
    return this.axiosClient('/Channel/report', {
      url: '/1/api/user/code_login',
      type: 'post',
      param: _objectSpread(_objectSpread({}, {
        redirect_uri: this.config.redirect_uri,
        business: this.config.business
      }), {}, {
        name: name,
        code: code
      })
    }, 'post');
  },
  /**
     * 第三方登录获取用户token
     * @param {*} code 第三方登录返回code
     */
  code2Token: function code2Token(code) {
    return this.axiosClient('/channel/getacctoken', {
      code: code,
      callbackurl: encodeURIComponent(this.website)
    }, 'post');
  },
  /**
     * 获取验证码
     */
  getVerify: function getVerify() {
    return "".concat(this.config.baseUrl, "/channel/captcha?").concat(new Date().valueOf());
  },
  /**
     * 检测验证码是否正确
     * @param {*} captcha 验证码
     */
  checkVerify: function checkVerify(captcha) {
    return this.axiosClient('/channel/check', {
      captcha: captcha,
      h5: 1
    });
  }
};
export default apiConfig;